// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LineChartOutlinedSvg from "@fishx/icons-svg/es/asn/LineChartOutlined";
import FishxIcon from '../components/FishxIcon';

var LineChartOutlined = function LineChartOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LineChartOutlinedSvg
  }));
};

LineChartOutlined.displayName = 'LineChartOutlined';
export default React.forwardRef(LineChartOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LineChartOutlined.js
// module id = 3046
// module chunks = 0